import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const SellerLogin = () => {
  const navigate = useNavigate();

  const handleLogin = (event) => {
    event.preventDefault();
    navigate('/dashboard');
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-200">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-sm">
        <h2 className="text-2xl font-bold mb-4">Seller Login</h2>
        <form onSubmit={handleLogin}>
          <div className="mb-4">
            <label htmlFor="email" className="block text-gray-700">Email ID / Phone Number</label>
            <input type="text" id="email" className="w-full p-2 border rounded-md" required />
          </div>
          <div className="mb-4">
            <label htmlFor="password" className="block text-gray-700">Password</label>
            <input type="password" id="password" className="w-full p-2 border rounded-md" required />
          </div>
          <button type="submit" className="w-full bg-green-500 text-white py-2 rounded-md hover:bg-green-700">Login</button>
        </form>
        <div className="mt-4 text-center">
          <Link to="/create-account" className="text-blue-500 hover:underline">Create an account</Link>
        </div>
      </div>
    </div>
  );
};

export default SellerLogin;
